module.exports = __webpack_public_path__ + "img/IDOO.6e3c5c29.png";